const TimeFormats = {
    YEAR_DAY: 'YYYY-MM-DD',
    HOUR_MINUTE: 'HH:mm',
    HOUR_MINUTE_SECOND: 'HH:mm',
    MINUTE_SECOND: 'mm:ss',
    CUBE_UTC_FULL_DATETIME: 'YYYY-MM-DDTHH:mm:ss.SSS',
};

export default TimeFormats;
